export default __webpack_public_path__ + "846f5bb02531c20d20f16dad8d47e96a.png";